/**
 * Categories the org-level default sending mailbox / default Cc recipients
 * are configured per: "orders" is sales orders, "purchase_orders" is
 * procurement POs, and "general" covers everything else. Strict semantics:
 * "general" is NOT a fallback for the specific categories.
 */
export const EMAIL_SEND_CATEGORIES = [
  "general",
  "orders",
  "purchase_orders",
  "discounts",
] as const;

export type EmailSendCategory = (typeof EMAIL_SEND_CATEGORIES)[number];
